var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCropSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488 352H448V96C448 78.375 433.625 64 416 64H192V160H352V488C352 501.25 362.75 512 376 512H424C437.25 512 448 501.25 448 488V448H488C501.25 448 512 437.25 512 424V376C512 362.75 501.25 352 488 352ZM160 24C160 10.75 149.25 0 136 0H88C74.75 0 64 10.75 64 24V64H24C10.75 64 0 74.75 0 88V136C0 149.25 10.75 160 24 160H64V416C64 433.625 78.375 448 96 448H320V352H160V24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCropSimple);
export default __webpack_public_path__ + "static/media/crop-simple.46ae030af4c7658e43719692bbcea9dc.svg";
export { ForwardRef as ReactComponent };